interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) {
    pages.push(i);
  }

  const baseBtn =
    "min-w-9 h-9 px-2 flex items-center justify-center rounded-md text-sm transition-colors cursor-pointer";

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-8">
      <button
        type="button"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
        <span className="hidden sm:inline">上一页</span>
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onPageChange(1)}
            className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400`}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onPageChange(page)}
          className={`${baseBtn} ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            onClick={() => onPageChange(totalPages)}
            className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400`}
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <span className="hidden sm:inline">下一页</span>
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}